import { useEffect, useState } from "react";
import { Modal } from "../../../../components";
import { useForm } from "react-hook-form";
import { setJefe } from "../handlers";

export default function CrearJefeComuna(props) {
  const [rta, setRta] = useState({
    data: null,
    error: null,
    loading: false,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();

  const enviar = async (datos) => {
    datos.barrio_id = props.id;
    setJefe(rta, setRta, datos);
  };

  useEffect(() => {
    if (rta.data && rta.error == null) {
      props.actualizarJefes();
      props.setOpen(false);
    }
  }, [rta]);

  return (
    <Modal
      loading={rta.loading}
      show={props.open}
      onHide={props.setOpen}
      title={() => {
        return "Crear Jefe de Comuna";
      }}
    >
      <form onSubmit={handleSubmit(enviar)}>
        <fieldset disabled={rta.loading}>
          <label>Nombre Completo:</label>
          <input
            className="form-control"
            {...register("nombre", {
              required: "El nombre es requerido",
              minLength: {
                value: 3,
                message: "Minimo 3 caracteres",
              },
            })}
          />
          <div className="mt-1" style={{ height: "26px" }}>
            {errors.nombre && <span className="text-danger">{errors.nombre.message}</span>}
          </div>

          <label>Teléfono:</label>
          <input
            className="form-control"
            {...register("telefono", {
              required: "El teléfono es requerido",
            })}
          />
          <div className="mt-1" style={{ height: "26px" }}>
            {errors.telefono && <span className="text-danger">{errors.telefono.message}</span>}
          </div>

          <label>DNI:</label>
          <input
            className="form-control"
            {...register("dni", {
              required: "El DNI es requerido",
              min: {
                value: 1000000,
                message: "Minimo 1000000",
              },
              max: {
                value: 99999999,
                message: "Maximo 99999999",
              },
            })}
            type="number"
          />
          <div className="mt-1" style={{ height: "26px" }}>
            {errors.dni && <span className="text-danger">{errors.dni.message}</span>}
          </div>

          <button type="submit" className="btn btn-sm btn-primary mt-2 d-flex">
            Guardar Jefe de Comuna{" "}
            {rta.loading && (
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-primary" role="status"></div>
              </div>
            )}
          </button>
        </fieldset>
      </form>
    </Modal>
  );
}
